import L from 'leaflet';

export const initializeBingLayer = () => {
    return L.tileLayer.bing({
        bingMapsKey: 'AiB4rZCVez2tdBNvzHCbKFemrAhA4Uq3qdisNGCAnQ6bcTIkqlg2FuVGlwh79u15',
        imagerySet: 'Aerial', // Choose from 'Aerial', 'AerialWithLabels', or 'Road',
        maxZoom: 21,
    });
};
